export default (() => {
  // Service archive filters
  const serviceFilter = $('.filters-wrapper select')
  serviceFilter.on('change', function () {
    const filter = $(this).val(); // get selected value
    if (filter) { // require a URL
      window.location = filter; // redirect
    }
    return false;
  });
})();



// WEBPACK FOOTER //
// ./scripts/layout/filters.js